import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

export const useGetConfigurationKeys = (): {
  keys: string[];
  loading: boolean;
  error: any;
  refetch: () => void;
} => {
  const { data, loading, error, refetch } = useQuery(
    gql`
      query {
        configurationKeys
      }
    `,
    {
      fetchPolicy: 'network-only',
      variables: {},
    },
  );

  return {
    keys: data?.configurationKeys,
    loading,
    error,
    refetch,
  };
};
